module.exports = __webpack_public_path__ + "static/media/CV_picture.2cee2f19.jpg";